import { TAccountPageType } from '@boss/utils';

export type PermissionRequirement = 'showprice' | 'canorder' | 'both';

export const isBlocked = (
  requirement: PermissionRequirement | undefined,
  showprice: boolean,
  canorder: boolean,
): boolean => {
  if (requirement === undefined) {
    return false;
  }
  if (requirement === 'showprice') {
    return !showprice;
  }
  if (requirement === 'canorder') {
    return !canorder;
  }
  if (requirement === 'both') {
    return !showprice && !canorder;
  }
  return false;
};

export const ACCOUNT_TAB_PERMISSIONS: Partial<Record<TAccountPageType, PermissionRequirement>> = {
  INVOICES: 'showprice',
  PRICE_LIST: 'showprice',
  DISCOUNT: 'showprice',
  ORDER_IMPORT: 'canorder',
  // [45975] ORDERS is deliberately unguarded: the Bestellingen menu item and the
  // orders list/detail pages stay reachable even when showprice = false AND
  // canorder = false. The reorder action on order detail remains gated by
  // canorder alone (see containers/accountPage/orders/detail/b2b.tsx).
  LIST: 'both',
  PROJECTS: 'both',
  COLORS: 'both',
};

export const filterBlockedAccountPages = (
  pages: readonly TAccountPageType[],
  showprice: boolean,
  canorder: boolean,
): TAccountPageType[] => pages.filter(page => !isBlocked(ACCOUNT_TAB_PERMISSIONS[page], showprice, canorder));
